import React from 'react';
import clsx from 'clsx';
import { Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const clearOrAscending = (canBeCleared) => (canBeCleared ? 'clear' : 'ascending');
const clearOrSort = (asc, canBeCleared) => (asc ? 'descending' : clearOrAscending(canBeCleared));
const staticTitle = (sorted, asc) => (sorted ? `table.sorted.${asc ? 'ascending' : 'descending'}` : null);
const clickableTitle = (sorted, asc, canBeCleared) => (
  `table.sort.${sorted ? clearOrSort(asc, canBeCleared) : 'ascending'}`
);

const SortedColumnIcon = ({
  sorted,
  asc,
  onClick,
  canBeCleared,
}) => {
  const intl = useIntl();
  return (
    <Icon
      name={sorted ? `sort ${asc ? 'up' : 'down'}` : 'sort'}
      onClick={onClick}
      title={intl.formatMessage({ id: onClick ? clickableTitle(sorted, asc, canBeCleared) : staticTitle(sorted, asc) })}
      className={clsx('table-sort-icon', onClick && 'pointer')}
    />
  );
};

export default SortedColumnIcon;
